const languages = [
  {
    "name": "Amharic",
    "code": "am",
    "nativeName": "አማርኛ"
  },
  {
    "name": "Arabic",
    "code": "ar",
    "nativeName": "العربية"
  },
  {
    "name": "Armenian",
    "code": "hy",
    "nativeName": "Հայերեն"
  },
  {
    "name": "Azerbaijani",
    "code": "az",
    "nativeName": "azərbaycan dili"
  },
  {
    "name": "Belarusian",
    "code": "be",
    "nativeName": "Беларуская"
  },
  {
    "name": "Bengali",
    "code": "bn",
    "nativeName": "বাংলা"
  },
  {
    "name": "Bulgarian",
    "code": "bg",
    "nativeName": "български език"
  },
  {
    "name": "Catalan; Valencian",
    "code": "ca",
    "nativeName": "Català"
  },
  {
    "name": "Chinese",
    "code": "zh",
    "nativeName": "中文 (Zhōngwén), 汉语, 漢語"
  },
  {
    "name": "Czech",
    "code": "cs",
    "nativeName": "česky, čeština"
  },
  {
    "name": "English",
    "code": "en",
    "nativeName": "English"
  },
  {
    "name": "Estonian",
    "code": "et",
    "nativeName": "eesti, eesti keel"
  },
  {
    "name": "French",
    "code": "fr",
    "nativeName": "français"
  },
  {
    "name": "German",
    "code": "de",
    "nativeName": "Deutsch"
  },
  {
    "name": "Hausa",
    "code": "ha",
    "nativeName": "Hausa, هَوُسَ"
  },
  {
    "name": "Hindi",
    "code": "hi",
    "nativeName": "हिन्दी, हिंदी"
  },
  {
    "name": "Hungarian",
    "code": "hu",
    "nativeName": "Magyar"
  },
  {
    "name": "Italian",
    "code": "it",
    "nativeName": "Italiano"
  },
  {
    "name": "Japanese",
    "code": "ja",
    "nativeName": "日本語 (にほんご／にっぽんご)"
  },
  {
    "name": "Javanese",
    "code": "jv",
    "nativeName": "basa Jawa"
  },
  {
    "name": "Khmer",
    "code": "km",
    "nativeName": "ភាសាខ្មែរ"
  },
  {
    "name": "Korean",
    "code": "ko",
    "nativeName": "한국어 (韓國語), 조선말 (朝鮮語)"
  },
  {
    "name": "Latvian",
    "code": "lv",
    "nativeName": "latviešu valoda"
  },
  {
    "name": "Malay",
    "code": "ms",
    "nativeName": "bahasa Melayu, بهاس ملايو‎"
  },
  {
    "name": "Marathi (Marāṭhī)",
    "code": "mr",
    "nativeName": "मराठी"
  },
  {
    "name": "Persian",
    "code": "fa",
    "nativeName": "فارسی"
  },
  {
    "name": "Polish",
    "code": "pl",
    "nativeName": "polski"
  },
  {
    "name": "Pashto, Pushto",
    "code": "ps",
    "nativeName": "پښتو"
  },
  {
    "name": "Portuguese",
    "code": "pt",
    "nativeName": "Português"
  },
  {
    "name": "Romanian, Moldavian, Moldovan",
    "code": "ro",
    "nativeName": "română"
  },
  {
    "name": "Russian",
    "code": "ru",
    "nativeName": "русский язык"
  },
  {
    "name": "Spanish",
    "code": "es",
    "nativeName": "Español"
  },
  {
    "name": "Swahili",
    "code": "sw",
    "nativeName": "Kiswahili"
  },
  {
    "name": "Tamil",
    "code": "ta",
    "nativeName": "தமிழ்"
  },
  {
    "name": "Telugu",
    "code": "te",
    "nativeName": "తెలుగు"
  },
  {
    "name": "Thai",
    "code": "th",
    "nativeName": "ไทย"
  },
  {
    "name": "Turkish",
    "code": "tr",
    "nativeName": "Türkçe"
  },
  {
    "name": "Ukrainian",
    "code": "uk",
    "nativeName": "українська"
  },
  {
    "name": "Uzbek",
    "code": "uz",
    "nativeName": "zbek, Ўзбек, أۇزبېك‎"
  },
  {
    "name": "Vietnamese",
    "code": "vi",
    "nativeName": "Tiếng Việt"
  }
];

export default languages;
